import type { BrandingConfig } from './types';

/**
 * Fallback tenant used before a meeting's branding resolves and for the
 * standalone demo. Real tenants arrive via a meeting's `branding_config`.
 */
export const DEFAULT_BRANDING: BrandingConfig = {
  tenantId: 'default',
  name: 'NSI',
  logoUrl: '/images/icon2.png',
  tint: null,
};
